import http from "../http-common";
import authHeader from "./authHeader";
import { INQUIRY_API } from "../api";

const getAllInquiry = () => {
  return http.get(`${INQUIRY_API}`, { headers: authHeader() });
};

const createInquiry = (data) => {
  return http.post(`${INQUIRY_API}`, data, { headers: authHeader() });
};

const updateInquiry = (data, id) => {
  return http.put(`${INQUIRY_API}/${id}`, data, { headers: authHeader() });
};
const replyInquiry = (id, data) => {
  return http.put(`${INQUIRY_API}/reply/${id}`, data, { headers: authHeader() });
};

const acceptInquiry = (id) => {
  return http.put(`${INQUIRY_API}/accept/${id}`, { headers: authHeader() });
};

const getInquiryById = (id) => {
  return http.get(`${INQUIRY_API}/${id}`, { headers: authHeader() });
};

const getInquiryByNIC = (nic) => {
  return http.get(`${INQUIRY_API}/nic/${nic}`, { headers: authHeader() });
};

const InquiryService = {
  getAllInquiry,
  // getAllInquiryOfCustomer,
  createInquiry,
  updateInquiry,
  getInquiryByNIC,
  // getAllInquiryOfTypesOfCustomer,
  replyInquiry,
  getInquiryById,
  acceptInquiry,
};

export default InquiryService;
